<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Richard Stanton and his wife, Gay, lived and worked in the city of Sydney. In 1882, his forebears established a commercial property agency where, generations later, Richard made his career. He became CEO and Chairman and expanded the name across the five major Australian cities. The Stantons have three daughters and live on a small cattle property in the Upper Hunter district, north of Sydney. The land has a river frontage and has views of the Great Dividing Range.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?49861f2a